export interface SettlementState {
  ui: SettlementUi;
  successfulOrders: any[];
  selectedOrderId: string | undefined;
  range: { from: string | undefined; to: string | undefined } | undefined;
  searchInput: string;
  page: number;
  orderType: "SUCCESSFULL" | "CANCELLED";
  orderDetail?: any;
  orderRevisionDetail?: any;
  billingPeriods?: BillingPeriod[];
  revision: { reason: OrderRevisionReason | undefined; comment: string } | undefined;
}
export interface SettlementUi {
  lastPage: boolean;
  isLoading: boolean;
}

export enum CancellationMoment {
  RT_UNASSIGNED = "RT_UNASSIGNED",
  RT_TO_STORE = "RT_TO_STORE",
  RT_IN_STORE = "RT_IN_STORE",
  RT_TO_USER = "RT_TO_USER",
  RT_AT_USER = "RT_AT_USER",
}

export enum OrderRevisionReason {
  BASE_CHARGE_INCORRECT = "BASE_CHARGE_INCORRECT",
  DISTANCE_CHARGE_INCORRECT = "DISTANCE_CHARGE_INCORRECT",
  WT_CHARGE_INCORRECT = "WT_CHARGE_INCORRECT",
  FINISHED_BUT_UNDELIVERED = "FINISHED_BUT_UNDELIVERED",
  FINISHED_BUT_RETURNED = "FINISHED_BUT_RETURNED",
  CANCELLED_BUT_FINISHED = "CANCELLED_BUT_FINISHED",
  RETURNED_BUT_CANCELLED = "RETURNED_BUT_CANCELLED",
  CANCELATION_CHARGE_INCORRECT = "CANCELATION_CHARGE_INCORRECT",
  OTHER = "OTHER",
}

export enum OrderRevisionStatus {
  IN_REVIEW = "IN_REVIEW",
  REQUEST_ACTION = "REQUEST_ACTION",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
}

export interface CreateOrderRevisionInput {
  order_id: number;
  reason: OrderRevisionReason;
  comment: string;
  attachments: readonly File[];
}

export interface AdditionalRevisionInfoInput {
  order_revision_id: number;
  comment: string;
  attachments: File[];
}

export interface BillingPeriod {
  end_date: string;
  first_order_date: string;
  id: number;
  last_order_date: string;
  num_orders: number;
  retention_date: string;
  start_date: string;
  total_charge: number;
}
